import React from 'react';
import ChecklistIcon from '@mui/icons-material/Checklist';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import GroupsIcon from '@mui/icons-material/Groups';

const TaskTypeIcon = ({ value }) => {
	return value === 'CALL' ? (
		<PhoneIcon size='small' />
	) : value === 'EMAIL' ? (
		<EmailIcon size='small' />
	) : value === 'MEETING' ? (
		<GroupsIcon size='small' />
	) : (
		<ChecklistIcon size='small' />
	);
};

export default TaskTypeIcon;
